import {
  RATE_TIME_FORMAT,
  RATE_TIME_PLACEHOLDER,
  SECONDS_PER_HOUR,
  SECONDS_PER_MINUTE,
} from './constants';

import type { Moment } from 'moment';
import type { DurationTimeParts } from './types';

export function getDurationTimeParts(seconds: number): DurationTimeParts {
  return {
    hours: String(Math.floor(seconds / SECONDS_PER_HOUR)).padStart(2, '0'),
    minutes: String(Math.floor((seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE)).padStart(
      2,
      '0',
    ),
    seconds: String(seconds % SECONDS_PER_MINUTE).padStart(2, '0'),
  };
}

export function formatDurationTime(seconds: number): string {
  const parts = getDurationTimeParts(seconds);

  return `${parts.hours} h : ${parts.minutes} m : ${parts.seconds} s`;
}

export function getBoundedDuration(
  duration: number,
  delta: number,
  durationLimitInSeconds: number,
): number {
  return Math.min(
    Math.max(duration + delta, 1),
    duration + Math.max(durationLimitInSeconds, 0),
  );
}

export function formatRateEventTime(time: Moment | null): string {
  return time ? time.format(RATE_TIME_FORMAT) : RATE_TIME_PLACEHOLDER;
}

export function resolveRateEventTime(
  selectedTime: Moment | null,
  minTime: Moment | null,
  maxTime: Moment | null,
): Moment | null {
  if (!selectedTime || !minTime || !maxTime) return null;

  const resolvedTime = minTime
    .clone()
    .hour(selectedTime.hour())
    .minute(selectedTime.minute())
    .second(selectedTime.second())
    .millisecond(0);

  if (maxTime.isAfter(minTime, 'day') && resolvedTime.isBefore(minTime)) {
    resolvedTime.add(1, 'day');
  }

  if (resolvedTime.isSameOrBefore(minTime)) {
    return minTime.clone().add(1, 'second');
  }

  if (resolvedTime.isSameOrAfter(maxTime)) {
    return maxTime.clone().subtract(1, 'second');
  }

  return resolvedTime;
}
